module.exports = __webpack_public_path__ + "img/8.788b883.jpg";